module.exports = __webpack_public_path__ + "assets/icons/ic_error_24px.svg";